<div class="detail-container" [testId]="'systemapp-detail-container'">
  <form nz-form [formGroup]="form" [testId]="'systemapp-detail-form'">
    <nz-card
      [nzTitle]="isAdd ? ('systemapp.detail.title.add' | i18n) : ('systemapp.detail.title.edit' | i18n)"
      [testId]="'systemapp-detail-card'"
    >
      <div nz-row [nzGutter]="16" [testId]="'systemapp-detail-row-app-id'">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzSpan]="4">{{ 'systemapp.id' | i18n }}</nz-form-label>
            <nz-form-control [nzSpan]="20">
              <nz-input-group [nzSuffix]="suffixId">
                <input nz-input [value]="systemAppId || '-'" readonly [testId]="'systemapp-detail-id'" />
              </nz-input-group>
              <ng-template #suffixId>
                <ng-container *ngIf="systemAppId">
                  <i
                    nz-icon
                    nzType="copy"
                    nzTheme="outline"
                    style="cursor: pointer"
                    (click)="copyText(systemAppId)"
                    [testId]="'systemapp-detail-id-copy'"
                  ></i>
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="16" *ngIf="secretKey" [testId]="'systemapp-detail-row-app-secret'">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzSpan]="4">{{ 'systemapp.secret-key' | i18n }}</nz-form-label>
            <nz-form-control [nzSpan]="20">
              <nz-input-group [nzSuffix]="suffixSecret">
                <input nz-input [value]="showSecret ? secretKey : '***'" readonly [testId]="'systemapp-detail-secret-key'" />
              </nz-input-group>
              <ng-template #suffixSecret>
                <i
                  nz-icon
                  [nzType]="showSecret ? 'eye-invisible' : 'eye'"
                  nzTheme="outline"
                  style="cursor: pointer"
                  (click)="toggleSecret()"
                  [testId]="'systemapp-detail-secret-eye'"
                ></i>
                <i
                  nz-icon
                  nzType="copy"
                  nzTheme="outline"
                  style="cursor: pointer"
                  (click)="copyText(secretKey)"
                  [testId]="'systemapp-detail-secret-copy'"
                ></i>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="16" [testId]="'systemapp-detail-row-name'">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzRequired]="true" [nzSpan]="4">{{ 'systemapp.name' | i18n }}</nz-form-label>
            <nz-form-control [nzSpan]="20">
              <input nz-input formControlName="name" [testId]="'systemapp-detail-name-input'" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="16" [testId]="'systemapp-detail-row-system-code'">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzRequired]="true" [nzSpan]="4">{{ 'systemapp.system-code' | i18n }}</nz-form-label>
            <nz-form-control [nzSpan]="20">
              <input nz-input formControlName="systemCode" [testId]="'systemapp-detail-systemcode-input'" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="16" [testId]="'systemapp-detail-row-description'">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzRequired]="true" [nzSpan]="4">{{ 'systemapp.description' | i18n }}</nz-form-label>
            <nz-form-control [nzSpan]="20">
              <textarea nz-input rows="2" formControlName="description" [testId]="'systemapp-detail-description-input'"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="footer-buttons" [testId]="'systemapp-detail-footer-buttons'">
        <button nz-button nzType="default" (click)="cancel()" [disabled]="submitting" [testId]="'systemapp-detail-cancel'">{{
          'common.cancel' | i18n
        }}</button>
        <button nz-button nzType="primary" (click)="save()" [nzLoading]="submitting" [testId]="'systemapp-detail-save'">{{
          'common.save' | i18n
        }}</button>
      </div>
    </nz-card>
  </form>
</div>
